import { useReactiveVar } from "@apollo/client";
import { useLocation } from "react-router-dom";
import { TFLocationState } from "types/topicflow";

import { currentUserVar, leftSidePanelVar } from "@cache/cache";
import Avatar from "@components/avatar/avatar";
import Link from "@components/link/link";
import { getTopicflowIcon } from "@components/topicflow-icon/topicflow-icon-helpers";
import { classNames } from "@helpers/css";
import { assertEdgesNonNull, getUrl, toWithBackground } from "@helpers/helpers";

const InviteIcon = getTopicflowIcon("userPlus02");
const OrgChartIcon = getTopicflowIcon("dataflow");

const SidebarReportsExpanded = () => {
  const leftSidePanel = useReactiveVar(leftSidePanelVar);
  const reportsPanelOpen = leftSidePanel === "reports";
  const currentUser = currentUserVar();
  const location = useLocation<TFLocationState>();
  const directReports = assertEdgesNonNull(currentUser.directReports);

  if (!reportsPanelOpen) {
    return null;
  }

  return (
    <div className="bg-sidenav-back flex-1 flex flex-col overflow-hidden border-gray-200">
      <div className="px-3 pt-4 pb-5 flex flex-col gap-0.5">
        <Link
          to={toWithBackground({ pathname: "/invite", location })}
          className="flex items-center gap-2 px-2 py-1 rounded text-sm text-gray-800 hover:bg-nav-item-active"
        >
          <InviteIcon className="h-4 w-4 shrink-0 text-gray-500" />
          Invite people
        </Link>
        <Link
          to="/org-chart"
          className="flex items-center gap-2 px-2 py-1 rounded text-sm text-gray-800 hover:bg-nav-item-active"
        >
          <OrgChartIcon className="h-4 w-4 shrink-0 text-gray-500" />
          Org chart
        </Link>
      </div>
      <div className="flex-1 overflow-y-auto scrollbar-hidden px-3 pb-4">
        <div className="flex flex-col gap-0.5">
          {directReports.map((user: any) => {
            const profileUrl = getUrl({ userId: user.id });
            return (
              <Link
                key={user.id}
                to={profileUrl}
                className={classNames(
                  "flex items-center gap-2 px-2 py-1 rounded hover:bg-nav-item-active",
                  window.location.href.startsWith(
                    `${window.location.origin}${profileUrl}`,
                  )
                    ? "bg-nav-item-active"
                    : "",
                )}
              >
                <Avatar user={user} size="4" showTooltip={false} />
                <span className="text-gray-800 text-sm font-normal truncate">
                  {user.name}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SidebarReportsExpanded;
